/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse20015,
    InlineResponse20015FromJSON,
    InlineResponse20015ToJSON,
    ReadOnlyFuelCardSerializer,
    ReadOnlyFuelCardSerializerFromJSON,
    ReadOnlyFuelCardSerializerToJSON,
    WriteOnlyFuelCardSerializer,
    WriteOnlyFuelCardSerializerFromJSON,
    WriteOnlyFuelCardSerializerToJSON,
} from '../models';

export interface FuelCardCreateRequest {
    data: WriteOnlyFuelCardSerializer;
}

export interface FuelCardDeleteRequest {
    id: number;
}

export interface FuelCardListRequest {
    status?: string;
    textSearch?: string;
    limit?: number;
    offset?: number;
}

export interface FuelCardPartialUpdateRequest {
    id: number;
    data: WriteOnlyFuelCardSerializer;
}

export interface FuelCardReadRequest {
    id: number;
}

export interface FuelCardUpdateRequest {
    id: number;
    data: WriteOnlyFuelCardSerializer;
}

/**
 * no description
 */
export class FuelCardApi extends runtime.BaseAPI {

    /**
     */
    async fuelCardCreateRaw(requestParameters: FuelCardCreateRequest): Promise<runtime.ApiResponse<ReadOnlyFuelCardSerializer>> {
        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling fuelCardCreate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-card/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyFuelCardSerializerToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFuelCardSerializerFromJSON(jsonValue));
    }

    /**
     */
    async fuelCardCreate(requestParameters: FuelCardCreateRequest): Promise<ReadOnlyFuelCardSerializer> {
        const response = await this.fuelCardCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async fuelCardDeleteRaw(requestParameters: FuelCardDeleteRequest): Promise<runtime.ApiResponse<ReadOnlyFuelCardSerializer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling fuelCardDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-card/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFuelCardSerializerFromJSON(jsonValue));
    }

    /**
     */
    async fuelCardDelete(requestParameters: FuelCardDeleteRequest): Promise<ReadOnlyFuelCardSerializer> {
        const response = await this.fuelCardDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async fuelCardListRaw(requestParameters: FuelCardListRequest): Promise<runtime.ApiResponse<InlineResponse20015>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.textSearch !== undefined) {
            queryParameters['text_search'] = requestParameters.textSearch;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-card/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20015FromJSON(jsonValue));
    }

    /**
     */
    async fuelCardList(requestParameters: FuelCardListRequest): Promise<InlineResponse20015> {
        const response = await this.fuelCardListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async fuelCardPartialUpdateRaw(requestParameters: FuelCardPartialUpdateRequest): Promise<runtime.ApiResponse<ReadOnlyFuelCardSerializer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling fuelCardPartialUpdate.');
        }

        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling fuelCardPartialUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-card/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyFuelCardSerializerToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFuelCardSerializerFromJSON(jsonValue));
    }

    /**
     */
    async fuelCardPartialUpdate(requestParameters: FuelCardPartialUpdateRequest): Promise<ReadOnlyFuelCardSerializer> {
        const response = await this.fuelCardPartialUpdateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async fuelCardReadRaw(requestParameters: FuelCardReadRequest): Promise<runtime.ApiResponse<ReadOnlyFuelCardSerializer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling fuelCardRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-card/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFuelCardSerializerFromJSON(jsonValue));
    }

    /**
     */
    async fuelCardRead(requestParameters: FuelCardReadRequest): Promise<ReadOnlyFuelCardSerializer> {
        const response = await this.fuelCardReadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async fuelCardUpdateRaw(requestParameters: FuelCardUpdateRequest): Promise<runtime.ApiResponse<ReadOnlyFuelCardSerializer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling fuelCardUpdate.');
        }

        if (requestParameters.data === null || requestParameters.data === undefined) {
            throw new runtime.RequiredError('data','Required parameter requestParameters.data was null or undefined when calling fuelCardUpdate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-card/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: WriteOnlyFuelCardSerializerToJSON(requestParameters.data),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFuelCardSerializerFromJSON(jsonValue));
    }

    /**
     */
    async fuelCardUpdate(requestParameters: FuelCardUpdateRequest): Promise<ReadOnlyFuelCardSerializer> {
        const response = await this.fuelCardUpdateRaw(requestParameters);
        return await response.value();
    }

}
